<template>
  <span v-editable="blok">
    <b-nav-item v-if="basket" :href="url">
      <span :class="classes">
        <span class="toggler-icon">
          <font-awesome-icon v-if="blok.icon" :icon="blok.icon" size="lg"/>{{ blok.label }}
          <b-badge v-if="blok.show_count" pill variant="primary">{{ basket ? calculateLineItemsTotal(basket.lineItems) : 0 }}</b-badge>
        </span>
        <span v-if="blok.show_value"> (<span v-mny="{ input: basket.paymentDue, currency: basket.currencyCode }"></span>)</span>
      </span>
    </b-nav-item>
  </span>
</template>
<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "shopify-basket",
  props: {
    blok: Object
  },
  computed: {
    ...mapState({
      basket: state => state.shopify.checkout
    }),
    classes: function() {
      return [this.$props.blok.classes].join(" ");
    },
    url: function() {
      const f = this.$options.filters;
      return this.$props.blok.alt_link.cached_url != '' ? f.formatSbInternalLink(this.$props.blok.alt_link.cached_url) : this.basket.webUrl;
    }
  },
  methods: {
    calculateLineItemsTotal: function(items) {
        return items.reduce( (a,v) => {
            return a + v.quantity;
        }, 0);
    }
  }
};
</script>
